module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lte-pagination pagination no-margin",
    class: ['pagination-' + _vm.size]
  }, [(!!_vm.firstText) ? _c('li', {
    class: {
      disabled: _vm.value <= 1
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(1, _vm.value <= 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.firstText))])]) : _vm._e(), _vm._v(" "), (!!_vm.prevText) ? _c('li', {
    class: {
      disabled: _vm.value <= 1
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(_vm.value - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.prevText))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageItems), function(p) {
    return _c('li', {
      class: {
        active: _vm.value === p.page
      },
      on: {
        "click": function($event) {
          _vm.setPageIndex(p.page)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(p.text))])])
  }), _vm._v(" "), (!!_vm.nextText) ? _c('li', {
    class: {
      disabled: _vm.value >= _vm.pageCount
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(_vm.value + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.nextText))])]) : _vm._e(), _vm._v(" "), (!!_vm.lastText) ? _c('li', {
    class: {
      disabled: _vm.value >= _vm.pageCount
    },
    on: {
      "click": function($event) {
        _vm.setPageIndex(_vm.pageCount, _vm.value >= _vm.pageCount)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.lastText))])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78897df2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/pagination.vue
// module id = 25
// module chunks = 0